import React from "react"
import styles from "../../styles/global.module.scss"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import {
  faMapMarker,
  faPhone,
  faEnvelope,
} from "@fortawesome/free-solid-svg-icons"

export default function ContactInformation(props) {
  const { metadata } = props
  return (
    <div id={styles.contactInformation}>
      <h2>Contact {metadata.CompanyName}</h2>
      <div className={`${styles.contactBlock} ${styles.flexWrapper}`}>
        <div className={styles.contactBlockLeft}>
          <FontAwesomeIcon icon={faMapMarker} />
        </div>
        <div className={styles.contactBlockRight}>
          <p>
            {metadata.CompanyAddress.street}, {metadata.CompanyAddress.city},{" "}
            {metadata.CompanyAddress.state} {metadata.CompanyAddress.zipcode}
          </p>
          <p></p>
        </div>
      </div>
      <div className={`${styles.contactBlock} ${styles.flexWrapper}`}>
        <div className={styles.contactBlockLeft}>
          <FontAwesomeIcon icon={faPhone} />
        </div>
        <div className={styles.contactBlockRight}>
          <p>
            <a
              href={`tel:${metadata.CompanyPhone}`}
              title={metadata.CompanyPhone}
            >
              {metadata.CompanyPhone}
            </a>
          </p>
        </div>
      </div>
      <div className={`${styles.contactBlock} ${styles.flexWrapper}`}>
        <div className={styles.contactBlockLeft}>
          <FontAwesomeIcon icon={faEnvelope} />
        </div>
        <div className={styles.contactBlockRight}>
          <p>
            <a
              href={`mailto:${metadata.CompanyEmail}`}
              title={metadata.CompanyEmail}
            >
              {metadata.CompanyEmail}
            </a>
          </p>
        </div>
      </div>
    </div>
  )
}
